import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from 'core/ui/Box';
import DatePickerRounded from 'core/ui/DatePickers/DatePickerRounded';
import { ButtonPrimary } from 'core/ui/Button';
import { Delete } from '@material-ui/icons';
import Paper from 'core/ui/Paper';
import Typography, { fontStyle } from 'core/ui/Typography';
import TextFieldRounded from 'core/ui/TextFieldRounded';
import Divider from 'core/ui/Divider';
import { IconButton } from '@material-ui/core';
import LoaderSm from 'core/ui/LoaderSm';
import { gymDate, usDateFormat } from 'core/utils/formatters';
import useCoachUnavailableTimes from './useCoachUnavailableTimes';

const AdminPaymentsReport = () => {
  const { t } = useTranslation();
  const {
    remove,
    save,
    loading,
    formData,
    setFormData,
    coachesUnavailableDates,
  } = useCoachUnavailableTimes();

  return (
    <Box mt={2}>
      <Box display="flex" mb={3} alignItems="flex-end" justifyContent="center" flexWrap="wrap">
        <Box ml={1}>
          <TextFieldRounded
            label={t('description')}
            placeholder={t('description')}
            value={formData?.description}
            onChange={(value) => setFormData((prev) => ({ ...prev, description: value }))}
            bordered
          />
        </Box>
        <Box ml={1}>
          <DatePickerRounded
            label={t('label.date')}
            value={formData?.date}
            onChange={(value) => setFormData((prev) => ({ ...prev, date: value }))}
            disablePast={false}
            usFormat={usDateFormat()}
            autoOk
            bordered
          />
        </Box>
        <Box ml={3}>
          <ButtonPrimary disabled={loading} onClick={() => save()}>
            <LoaderSm loading={loading} center />
            {t('button.add')}&nbsp;
          </ButtonPrimary>
        </Box>
      </Box>

      <Divider m={1} />

      <Box display="flex" mb={3} flexWrap="wrap">
        {coachesUnavailableDates?.map((date, index) => (
          <Paper elevation={1} className="paper-rounded" m={1} p={3} key={index}>
            <Box display="flex">
              <Box display="flex" flexDirection="column" flexGrow={1}>
                <Typography color="primary" variant="caption">
                  {date.description || t('unavailable')}
                </Typography>
                <Typography
                  mx={1}
                  component="div"
                  className="roboto-regular"
                  style={fontStyle.medium}
                >
                  {gymDate(date.date)}
                </Typography>
              </Box>

              <IconButton onClick={() => remove(date?.id)}>
                <Delete />
              </IconButton>
            </Box>
          </Paper>
        ))}
      </Box>
    </Box>
  );
};

export default AdminPaymentsReport;
